import {Methods} from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class AttendanceOriginalApi extends NewviewOaBaseApi {
   

  public get ControllerName(): any {
    return 'attendance-original'
  }


  /**
   * 导出
   * @returns 
   */
  public excel(params) {
    return this.download(params, "excel")
  }

  /**
   * 导出
   * @returns
   */
  public originalExcel(params) {
    return this.download(params, "originalExcel")
  }
  
  public  getmNoTimes(userId){
      return this.send({userId:userId},"getmNoTimes",Methods.GET)
  }
}